"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _keyCodes = require("../lib/keyCodes");

var ARROW_KEYS = [_keyCodes.UP, _keyCodes.DOWN, _keyCodes.RIGHT, _keyCodes.LEFT];
var DRAFT_EDITOR_CLASS = 'draft-extend';
var DRAFT_CONTROLS_CLASS = 'draft-extend-controls';

var getClassNames = function getClassNames(_ref) {
  var className = _ref.className;
  return className && (0, _immutable.OrderedSet)(className.split(' '));
};

var isNodeWithinClass = function isNodeWithinClass(classNames) {
  var targetSet = typeof classNames === 'string' ? _immutable.OrderedSet.of(classNames) : (0, _immutable.OrderedSet)(classNames);
  return function isContained(node) {
    if (!node) {
      return false;
    }

    var classNameSet = getClassNames(node);
    return classNameSet && classNameSet.intersect(targetSet).isEmpty() === false ? true : isContained(node.parentElement);
  };
};

var isNodeInEditor = function isNodeInEditor(node) {
  if (!node) {
    return false;
  }

  var classNameSet = getClassNames(node);

  if (classNameSet && classNameSet.has(DRAFT_CONTROLS_CLASS)) {
    return false;
  }

  return classNameSet && classNameSet.has(DRAFT_EDITOR_CLASS) ? true : isNodeInEditor(node.parentElement);
};

var _default = function _default(parentClasses) {
  var removable = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
  return function (WrappingComponent) {
    var isNodeWithinBlock = isNodeWithinClass(parentClasses);
    var WithAtomicFocus = (0, _createReactClass.default)({
      displayName: "WithAtomicFocus",
      propTypes: {
        block: _propTypes.default.object.isRequired
      },
      contextTypes: {
        getEditorState: _propTypes.default.func,
        onChange: _propTypes.default.func.isRequired,
        getReadOnly: _propTypes.default.func.isRequired,
        setReadOnly: _propTypes.default.func.isRequired
      },
      getInitialState: function getInitialState() {
        var isInitiallyReadOnly = this.context.getReadOnly();
        return {
          selected: false,
          overrideKeyDown: false,
          isInitiallyReadOnly: isInitiallyReadOnly
        };
      },
      componentDidMount: function componentDidMount() {
        this.listeners = {
          keydown: this.handleKeyDown,
          click: this.handleReadOnlyClick
        };
      },
      componentWillUnmount: function componentWillUnmount() {
        this.setListeners(false);
      },
      setListeners: function setListeners() {
        var _this = this;

        var add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var method = (add ? document.addEventListener : document.removeEventListener).bind(document);
        Object.keys(this.listeners).forEach(function (event) {
          method(event, _this.listeners[event]);
        });
      },
      overrideKeyDown: function overrideKeyDown() {
        this.setState({
          overrideKeyDown: true
        });
      },
      restoreKeyDown: function restoreKeyDown() {
        this.setState({
          overrideKeyDown: false
        });
      },
      handleReadOnlyClick: function handleReadOnlyClick(e) {
        var isInitiallyReadOnly = this.state.isInitiallyReadOnly;
        var _this$context = this.context,
            getReadOnly = _this$context.getReadOnly,
            getEditorState = _this$context.getEditorState,
            onChange = _this$context.onChange;

        if (isInitiallyReadOnly) {
          return;
        }

        if (getReadOnly() === true && isNodeWithinBlock(e.target) === false) {
          e.preventDefault();
          e.stopPropagation();
          this.blur();

          if (isNodeInEditor(e.target)) {
            var editorState = getEditorState();
            var currentKey = editorState.getSelection().get('anchorKey');
            var contentKeyBefore = editorState.getCurrentContent().getKeyBefore(currentKey);

            var updatedSelection = _draftJs.SelectionState.createEmpty(contentKeyBefore);

            onChange(_draftJs.EditorState.forceSelection(editorState, updatedSelection));
          }
        }
      },
      handleArrowKey: function handleArrowKey(keyCode) {
        var _this$context2 = this.context,
            getEditorState = _this$context2.getEditorState,
            onChange = _this$context2.onChange;
        var editorState = getEditorState();
        var currentContent = editorState.getCurrentContent();
        var currentKey = editorState.getSelection().get('anchorKey');
        var updatedSelection = editorState.getSelection();

        if (keyCode === _keyCodes.UP || keyCode === _keyCodes.LEFT) {
          var contentKeyBefore = currentContent.getKeyBefore(currentKey);

          if (contentKeyBefore) {
            var contentBlockBefore = currentContent.getBlockForKey(contentKeyBefore);
            var offset = contentBlockBefore.getLength() || 0;
            updatedSelection = _draftJs.SelectionState.createEmpty(contentKeyBefore).merge({
              anchorOffset: offset,
              focusOffset: offset
            });
          }
        }

        if (keyCode === _keyCodes.DOWN || keyCode === _keyCodes.RIGHT) {
          var contentKeyAfter = currentContent.getKeyAfter(currentKey);

          if (contentKeyAfter) {
            updatedSelection = _draftJs.SelectionState.createEmpty(contentKeyAfter);
          }
        }

        this.blur();
        onChange(_draftJs.EditorState.forceSelection(editorState, updatedSelection));
      },
      handleKeyDown: function handleKeyDown(e) {
        var _this$state = this.state,
            selected = _this$state.selected,
            overrideKeyDown = _this$state.overrideKeyDown;

        if (!selected || overrideKeyDown) {
          return;
        }

        var keyCode = e.keyCode;

        if (ARROW_KEYS.includes(keyCode)) {
          this.handleArrowKey(keyCode);
          e.preventDefault();
        } else if (keyCode === _keyCodes.BACKSPACE && removable === true) {
          this.removeBlock();
          e.preventDefault();
        }
      },
      removeBlock: function removeBlock() {
        var _this$context3 = this.context,
            onChange = _this$context3.onChange,
            getEditorState = _this$context3.getEditorState;
        var editorState = getEditorState();
        var selection = editorState.getSelection();
        var currentContent = editorState.getCurrentContent();
        var currentBlockKey = selection.get('anchorKey');
        var updatedBlockMap = currentContent.getBlockMap().delete(currentBlockKey);

        var updatedContent = _draftJs.ContentState.createFromBlockArray(updatedBlockMap.toArray());

        var updatedSelection;
        var precedingBlockKey = currentContent.getKeyBefore(currentBlockKey);

        if (precedingBlockKey) {
          var precedingBlock = currentContent.getBlockForKey(precedingBlockKey);
          var offset = precedingBlock ? precedingBlock.getLength() : 0;
          updatedSelection = _draftJs.SelectionState.createEmpty(precedingBlockKey).merge({
            anchorOffset: offset,
            focusOffset: offset
          });
        } else {
          updatedSelection = _draftJs.SelectionState.createEmpty();
        }

        this.blur();

        var updatedEditorState = _draftJs.EditorState.push(editorState, updatedContent, 'remove-range');

        onChange(_draftJs.EditorState.forceSelection(updatedEditorState, updatedSelection));
      },
      focus: function focus() {
        var block = this.props.block;
        var selected = this.state.selected;
        var _this$context4 = this.context,
            getEditorState = _this$context4.getEditorState,
            onChange = _this$context4.onChange,
            setReadOnly = _this$context4.setReadOnly;
        var editorState = getEditorState();
        var newSelection = editorState.getSelection();

        if (!selected) {
          newSelection = _draftJs.SelectionState.createEmpty(block.getKey());
          this.setListeners(true);
        }

        setReadOnly(true);
        onChange(_draftJs.EditorState.forceSelection(editorState, newSelection));
        this.setState({
          selected: true
        });
      },
      blur: function blur() {
        var setReadOnly = this.context.setReadOnly;
        setReadOnly(false);
        this.setListeners(false);
        this.setState({
          selected: false
        });
      },
      render: function render() {
        var selected = this.state.selected;
        return _react.default.createElement(WrappingComponent, Object.assign({}, this.props, {
          selected: selected,
          overrideKeyDown: this.overrideKeyDown,
          restoreKeyDown: this.restoreKeyDown,
          onFocus: this.focus
        }));
      }
    });
    WithAtomicFocus.WrappingComponent = WrappingComponent;
    return WithAtomicFocus;
  };
};

exports.default = _default;
module.exports = exports.default;